<router-outlet></router-outlet>
<div *ngIf="showCustomLoader" class="overlay">
    <div class="overlay__inner"></div>
</div>
<mat-progress-spinner *ngIf="showCustomLoader" color="primary" class="loader" mode="indeterminate"></mat-progress-spinner>